'use client';
import { Layer } from 'react-map-gl';
import { useMapTheme } from '../../context/map-context';

export function Waterway() {
  const config = useMapTheme();
  return (
    <Layer
      {...{
        id: 'waterway',
        type: 'line',
        source: 'openmaptiles',
        'source-layer': 'waterway',
        paint: {
          'line-color': config.theme.waterway,
          'line-width': {
            stops: [
              [8, 0.5],
              [9, 1],
              [15, 2],
              [16, 3],
            ],
          },
        },
      }}
    />
  );
}
